/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 3/23/16.
 */
'use strict';
angular.module('prism-ui.package').controller('PackagePreviewViewController', function (
    _,
    $element,
    $q,
    $rootScope,
    $scope,
    secFromTimecodeFilter,
    CreateProxyService,
    CreateSnapshotService,
    DynamicPropertiesService,
    DownloadAssetService,
    ModalService,
    PackageMediaService,
    PackageUtilService,
    PermissionsService,
    PreviewQueryService,
    ProxyPlayerService,
    Timecode,
    UtilsService
) {
    var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
    var DOWNLOAD_PROXY_STATE = 'PACKAGE_VIEW_DOWNLOAD_PROXY_VIEW_STATE';
    var RECREATE_PROXY_STATE = 'PACKAGE_RECREATE_PROXY_VIEW_STATE';
    var self = this;


    var startTimecodeInSeconds = 0;
    var programStartTimecodeInSeconds = 0;
    var programEndTimecodeInSeconds = 0;
    var playerProgramStartTime = 0;
    var playerProgramEndTime = 0;
    var defaultStartTimecode = '00:00:00:00';
    var mainVideoFrameRate;
    var currentlySelectedComponent;
    var VIDEO_AUDIO_ROLES = {
        mainVideo: {
            label: 'Main Video'
        }
    };

    self.currentViewedTab = 'details';
    self.creatingSnapshots = {};
    self.createdProxies = {};
    self.perms = {};
    self.loading = true;
    self.currentViewData = {partners: [], images: [], ccSubtitles: [], partnerArtworks: [], adpod: [], videosAudios: []};

    self.selectedPartner = undefined;
    self.selectedArtworkPartner = undefined;
    self.selectedArtworkLanguage = undefined;
    self.selectedArtwork = undefined;
    self.selectedVideoAudio = undefined;
    self.selectedCCSub = undefined;
    self.selectedImage = undefined;
    self.tempImagePath = undefined;
    self.availableElements = [];
    self.mainVideo = {};

    self.previewGridOptions = {
        rowHeight: 26,
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableFullRowSelection: false,
        enableCellSelection: true,
        enableCellEditOnFocus: true,
        multiSelect: false,
        enableColumnMenus: false,
        enableSorting: false,
        enableColumnResizing: true,
        modifierKeysToMultiSelectCells: true,
        enableVerticalScrollbar: 2,
        enablePaginationControls: false
    };

    self.adpodGrid = angular.copy(self.previewGridOptions);
    self.adpodGrid.columnDefs = [
        {
            field: 'name',
            allowCellFocus: false
        },
        {
            field: 'startTimeCode',
            name: 'In'
        },
        {
            field: 'endTimeCode',
            name: 'Out'
        }
    ];
    self.adpodGrid.onRegisterApi = function (gridApi) {
        gridApi.cellNav.on.navigate($scope, function (newRowCol) {
            var seekValue;
            if (newRowCol.col.field === 'startTimeCode') {
                seekValue = newRowCol.row.entity.startTime;
            }
            else {
                seekValue = newRowCol.row.entity.endTime;
            }
            ProxyPlayerService.seek(parseFloat(seekValue));
        });
    };
    self.componentsGrid = angular.copy(self.previewGridOptions);
    self.componentsGrid.columnDefs = [
        {
            field: 'name',
            allowCellFocus: false
        },
        {
            field: 'in'
        },
        {
            field: 'out'
        }
    ];

    var getSeekTime = function (timeCode, offsetTimeCode) {
        mainVideoFrameRate = parseFloat(self.mainVideo.mediaInfo.frameRate);
        return offsetTimeCode ?
            secFromTimecodeFilter(timeCode, mainVideoFrameRate) - secFromTimecodeFilter(self.mainVideo.startTimecode, mainVideoFrameRate)
            : secFromTimecodeFilter(timeCode, mainVideoFrameRate);
    };

    self.componentsGrid.onRegisterApi = function (gridApi) {
        gridApi.cellNav.on.navigate($scope, function (newRowCol) {
            var seekValue;
            var timeCode = newRowCol.row.entity[newRowCol.col.field];
            seekValue = getSeekTime(timeCode, true);
            ProxyPlayerService.seek(parseFloat(seekValue));
        });
    };
    self.captionsGrid = angular.copy(self.previewGridOptions);

    var defaultMediaRole = 'Main Video';
    var masterMediaData;

    var handleMasterOutOfBounds = function (timeCode) {
        ProxyPlayerService.onTimeUpdate = null;
        ProxyPlayerService.seek(timeCode);
        ProxyPlayerService.pause();
        ProxyPlayerService.onTimeUpdate = self.playerTimeChangeHandler;
    };

    self.playButtonStateChangeHandler = function (state) {
        if (state === 'play') {
            if (ProxyPlayerService.onTimeUpdate === null) {
                ProxyPlayerService.onTimeUpdate = self.playerTimeChangeHandler;
            }
        }
    };

    self.playerTimeChangeHandler = function (currentTime) {
        if (currentTime >= playerProgramEndTime) {
            handleMasterOutOfBounds(playerProgramEndTime);
        }
        if (currentTime < playerProgramStartTime) {
            handleMasterOutOfBounds(playerProgramStartTime);
        }
    };

    self.masterVideoOffsetChangeHandler = function () {
        if (self.useMasterVideoOffset && !self.selectedVideoAudio.prePostRollId && !self.selectedVideoAudio.isAudio) {
            ProxyPlayerService.seek(playerProgramStartTime);
            ProxyPlayerService.onTimeUpdate = self.playerTimeChangeHandler;
            ProxyPlayerService.onChangedState = self.playButtonStateChangeHandler;
        } else {
            ProxyPlayerService.seek(0);
            ProxyPlayerService.onTimeUpdate = null;
            ProxyPlayerService.onChangedState = null;
        }
    };

    var setPlayerProgramStart = function () {
        playerProgramStartTime = Timecode.fromSeconds(programStartTimecodeInSeconds - startTimecodeInSeconds,
            {frameRate: parseFloat(self.mainVideo.mediaInfo.frameRate), dropFrame: false});
        playerProgramStartTime = playerProgramStartTime.subtractFrames(10).frameCount / parseFloat(self.mainVideo.mediaInfo.frameRate);
    };

    var setPlayerProgramEnd = function () {
        playerProgramEndTime = Timecode.fromSeconds(programEndTimecodeInSeconds - startTimecodeInSeconds,
            {frameRate: parseFloat(self.mainVideo.mediaInfo.frameRate), dropFrame: false});
        playerProgramEndTime = playerProgramEndTime.addFrames(10).frameCount / parseFloat(self.mainVideo.mediaInfo.frameRate);
    };

    var setMasterVideo = function () {
        var startTimecode = self.mainVideoWithMediaInfo.video[0].startTimecode ? self.mainVideoWithMediaInfo.video[0].startTimecode : defaultStartTimecode;
        startTimecodeInSeconds = getSeekTime(startTimecode, false);
        self.previewPlayerOffset = startTimecodeInSeconds;

        if (self.mainVideoWithMediaInfo.video[0].acceptTemplateMember.acceptProfile.videoMasterType &&
            self.mainVideoWithMediaInfo.video[0].acceptTemplateMember.acceptProfile.videoMasterType.programTimingRequired) {
            programStartTimecodeInSeconds = getSeekTime(self.mainVideoWithMediaInfo.video[0].programStartTimecode, false);
            programEndTimecodeInSeconds = getSeekTime(self.mainVideoWithMediaInfo.video[0].programEndTimecode, false);
            setPlayerProgramStart();
            setPlayerProgramEnd();
            self.isMasterVideo = true;
            self.useMasterVideoOffset = true;
            self.masterVideoOffsetChangeHandler();
        }
    };

    var getMediaInfo = function (pkgMediaContents) {
        var promises = [];
        angular.forEach(pkgMediaContents, function (pkgMediaContent) {
            if (pkgMediaContent && pkgMediaContent.assetId && _.toLower(pkgMediaContent.type) !== 'videocomponentmaster') {
                var mediaInfoPromise = PreviewQueryService.getMediaInfo(pkgMediaContent.id, true)
                    .then(function (mediaInfo) {
                        pkgMediaContent.mediaInfo = mediaInfo;
                    });
                promises.push(mediaInfoPromise);
            }
        });

        return promises;
    };

    var getDefaultSubCC = function (ccSubs) {
        for (var i = 0; i < ccSubs.length; i++) {
            var ccSub = ccSubs[i];
            if (ccSub.languageId === self.mainVideo.languageId) {
                return ccSub;
            }
        }
        return ccSubs && ccSubs.length && ccSubs[0];
    };

    var getCCSubtitles = function (viewMedia) {
        var cc = viewMedia.cc;
        var subs = viewMedia.subtitle;
        var returnValue = [];
        if (cc && cc.length) {
            returnValue = subs && subs.length ? cc.concat(subs) : cc;
        }
        else if (subs && subs.length) {
            returnValue = subs;
        }
        return returnValue;
    };

    var createLanguageData = function(partner) {
        var tempPartnerLanguagesObject = {};
        // Keep one copy of each language
        _.forEach(partner.artworkAssets, function(artwork) {
            var language = {
                id: _.get(artwork, 'language.id', null),
                name: _.get(artwork, 'language.name', '[None]')
            };
            var languageData = _.get(tempPartnerLanguagesObject, language.id, {
                id: language.id,
                languageName: language.name,
                assets: []
            });
            if (!tempPartnerLanguagesObject[language.id]) {
                tempPartnerLanguagesObject[language.id] = languageData;
            }
            // Store artwork in language data
            languageData.assets.push(artwork);
        });

        return _.chain(tempPartnerLanguagesObject)
            .values() // Keep values from object
            .sortBy(function (languageData) {
                languageData.languageName.toLowerCase();
            })
            .forEach(function (languageData) { // Also sort all the assets by name
                _.sortBy(languageData.assets, function(asset) {
                    return asset.acceptProfile.name.toLowerCase();
                });
            })
            .value(); // Output sorted languagesData
    };

    var createArtworkData = function () {
        var partnersArtworkData = [];
        _.forEach(self.currentViewData.partners, function (partner) {
            if (partner.artworkAssets.length) {
                partnersArtworkData.push({
                    partnerName: partner.partner,
                    languagesData: createLanguageData(partner)
                });
            }
        });

        return _.orderBy(partnersArtworkData, function(partner) {
            return partner.partnerName.toLowerCase();
        });
    };

    var setVideoContentDefaults = function (viewMedia) {
        if (viewMedia && viewMedia.video && viewMedia.video.length) {
            if (!self.selectedPartner) {
                angular.forEach(masterMediaData, function (val, componentName) {
                    if (componentName !== defaultMediaRole) {
                        angular.forEach(masterMediaData[componentName].videocomponentmaster, function (componentMaster) {
                            self.currentViewData.videosAudios = self.currentViewData.videosAudios.concat(componentMaster);
                        });
                    } else {
                        self.currentViewData.videosAudios = self.currentViewData.videosAudios.concat(masterMediaData[defaultMediaRole].video);
                    }
                });
            }
            self.currentViewData.ccSubtitles = getCCSubtitles(viewMedia);
            if (viewMedia.adpod && viewMedia.adpod.length) {
                self.currentViewData.adpod = viewMedia.adpod;
            }
        }
    };

    var getPartnerRoles = function () {
        var roleMap = {};
        angular.forEach(self.currentViewData.partners, function (partnerPackage) {
            angular.forEach(partnerPackage.videoRoles, function (videoRole) {
                var key = videoRole.role.isRequired || masterMediaData[videoRole.role.name] ? videoRole.role.name : defaultMediaRole;
                var collection = roleMap[key];
                if (!collection) {
                    collection = [];
                    roleMap[key] = collection;
                }
                roleMap[key].push(partnerPackage.partner);
            });

        });
        return roleMap;
    };

    var getAvailableElements = function (partnerRoleMap) {
        var elements = [];
        angular.forEach(masterMediaData, function (val, componentName) {
            var elementString;
            var partners = partnerRoleMap && partnerRoleMap[componentName] ? partnerRoleMap[componentName].join(', ') : '';
            if (componentName !== defaultMediaRole) {
                elementString = defaultMediaRole + ' + ' + componentName;
                elements.push({
                    element: elementString,
                    partners: partners
                });
            }
            else { // Default role should always appear first
                elementString = componentName;
                elements.unshift({
                    element: elementString,
                    partners: partners
                });
            }
        });
        return elements;
    };

    var setNonVideoDefaults = function (viewMedia) {
        if (viewMedia && viewMedia.image && viewMedia.image.length) {
            self.currentViewData.images = viewMedia.image;
            self.selectedImage = self.currentViewData.images[0];
        }
        self.availableElements = getAvailableElements(getPartnerRoles());
        self.currentViewData.partnerArtworks = createArtworkData();
        self.selectedArtworkPartner = self.currentViewData.partnerArtworks[0];
    };

    var getCCSubsForPartner = function (partner) {
        var viewMedia;
        var defaultViewMedia = {
            roleName: defaultMediaRole,
            cc: masterMediaData[defaultMediaRole].cc,
            subtitle: masterMediaData[defaultMediaRole].subtitle
        };

        if (!partner.videoRoles.length) {
            viewMedia = defaultViewMedia;
        } else {
            angular.forEach(partner.videoRoles, function (videoRole) {
                if (videoRole.role.name === currentlySelectedComponent) {
                    var partnerCC = (masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].cc ) || masterMediaData[defaultMediaRole].cc;
                    var partnerSubs = (masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].subtitle) || masterMediaData[defaultMediaRole].subtitle;
                    viewMedia = {
                        roleName: videoRole.role.name,
                        cc: partnerCC,
                        subtitle: partnerSubs
                    };
                } else {
                    viewMedia = defaultViewMedia;
                }
            });
        }

        return getCCSubtitles(viewMedia);
    };

    self.getImageProxyPath = function() {
        if (self.canViewProxy()) {
            if (self.selectedImage && self.selectedImage.mediaPath) {
                return self.selectedImage.mediaPath;
            } else if (self.tempImagePath) {
                return self.tempImagePath;
            }
        }
        return 'assets/images/no-proxy.png';
    };

    self.getArtworkDropdownLabel = function(artwork) {
        return artwork.acceptProfile.name;
    };

    //Change here for preroll
    var getVideosForPartner = function (partner) {
        var partnerPreroll = partner.preRoll;
        var partnerPostroll = partner.postRoll;
        var partnerBreakPreRoll = partner.breakPreRoll;
        var partnerBreakPostRoll = partner.breakPostRoll;
        var allVideos = [];

        var componentMaster;
        if (partner.videoRoles.length) {
            angular.forEach(partner.videoRoles, function (videoRole) {
                if (videoRole.isRequired) {
                    componentMaster = masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].videocomponentmaster;
                }
                else {
                    componentMaster = (masterMediaData[videoRole.role.name] && masterMediaData[videoRole.role.name].videocomponentmaster) || masterMediaData[defaultMediaRole].video;
                }
                if (componentMaster) {
                    allVideos = allVideos.concat(componentMaster);
                }
            });
        }
        else {
            allVideos = allVideos.concat(masterMediaData[defaultMediaRole].video);
        }
        if (partnerPreroll) {
            allVideos.push(partnerPreroll);
        }
        if (partnerPostroll) {
            allVideos.push(partnerPostroll);
        }
        if (partnerBreakPreRoll && partnerBreakPostRoll) {
            allVideos.push(partnerBreakPreRoll);
            allVideos.push(partnerBreakPostRoll);
        }
        return allVideos;
    };

    var markerConversion = function () {
        self.markerTimecodesArray = [];
        var frameRate = parseFloat(self.mainVideo.mediaInfo.frameRate);
        var mainVideoFrames = Timecode.fromString(self.mainVideo.startTimecode, {
            frameRate: frameRate,
            dropFrame: false
        });

        angular.forEach(self.mainVideo.chapters, function (chapter, index) {
            var markerTimecodeObj = {};
            markerTimecodeObj.displayTimecode = 'Marker ' + (index + 1) + ' - ' + Timecode.fromString(chapter.startTimeCode, {
                frameRate: frameRate,
                dropFrame: false
            }).addFrames(mainVideoFrames.frameNumber).toString();
            markerTimecodeObj.chapterPlusOneFrameInSeconds = Timecode.fromString(chapter.startTimeCode, {
                frameRate: frameRate,
                dropFrame: false
            }).subtractFrames(1).frameCount / frameRate;
            self.markerTimecodesArray.push(markerTimecodeObj);
        });
    };

    var setVideoData = function () {
        self.selectedVideoAudio = self.currentViewData.videosAudios[0];
        self.selectedCCSub = getDefaultSubCC(self.currentViewData.ccSubtitles);
        if (self.selectedVideoAudio) {
            self.selectedVideoAudio.selectedMarker = undefined;
            self.adpodGrid.data = self.currentViewData.adpod && self.currentViewData.adpod.length ? self.currentViewData.adpod[0].adpods : undefined;
        }
        else {
            self.adpodGrid.data = self.currentViewData.adpod = [];
        }

        // For now, always add the main audio to all partners. Future work coming with partner specific audios
        if (masterMediaData[defaultMediaRole] && masterMediaData[defaultMediaRole].audio && masterMediaData[defaultMediaRole].audio.length) {
            self.currentViewData.videosAudios = self.currentViewData.videosAudios.concat(masterMediaData[defaultMediaRole].audio);
        }

        var mediaInfoPromises = getMediaInfo(self.currentViewData.videosAudios);
        $q.all(mediaInfoPromises).then(() => {
            _.forEach(masterMediaData, (mediaData) => {
                if (_.has(mediaData, 'videocomponentmaster')) {
                    // why don't video component masters have these!!
                    mediaData.videocomponentmaster[0].duration = masterMediaData[defaultMediaRole].video[0].duration;
                    mediaData.videocomponentmaster[0].durationTimecode = masterMediaData[defaultMediaRole].video[0].durationTimecode;
                    mediaData.videocomponentmaster[0].mediaInfo = masterMediaData[defaultMediaRole].video[0].mediaInfo;
                }
            });
            if (masterMediaData[defaultMediaRole] && masterMediaData[defaultMediaRole].video) {
                self.mainVideoWithMediaInfo = masterMediaData[defaultMediaRole];
                self.mainVideoMediaInfoFramerate = self.mainVideoWithMediaInfo.video[0].mediaInfo.frameRate;
                markerConversion();
                setMasterVideo();
            }
            $scope.$emit('server-busy', {working: false});
        });
    };

    var handleSelectedVideoAudioChange = function (selectedPartner) {
        if (self.selectedVideoAudio && self.selectedVideoAudio.dropdownLabel !== defaultMediaRole && !self.selectedVideoAudio.prePostRollId) {
            var componentsArray = [];
            currentlySelectedComponent = self.selectedVideoAudio.dropdownLabel.split('+')[1].trim();
            if (self.selectedPartner) {
                angular.forEach(selectedPartner.videoRoles, function (videoRole) {
                    if (videoRole.role.name === currentlySelectedComponent) {
                        angular.forEach(masterMediaData[currentlySelectedComponent].video, function (video) {
                            componentsArray.push(video);
                        });
                    }
                });
            } else {
                angular.forEach(masterMediaData, function (val, componentName) {
                    if (componentName === currentlySelectedComponent) {
                        angular.forEach(masterMediaData[currentlySelectedComponent].video, function (video) {
                            componentsArray.push(video);
                        });
                    }
                });
            }
            self.componentsGrid.data = componentsArray;
        }
    };

    var handlePartnerChange = function (selectedPartner) {
        $scope.$emit('server-busy', {working: true});
        if (!selectedPartner) {
            self.currentViewData.videosAudios = [];
            setVideoContentDefaults(masterMediaData[defaultMediaRole]);
        }
        else {
            self.currentViewData.videosAudios = getVideosForPartner(selectedPartner);
            self.selectedVideoAudio = self.currentViewData.videosAudios[0];
            handleSelectedVideoAudioChange(selectedPartner);
            self.currentViewData.ccSubtitles = self.currentViewData.videosAudios && self.currentViewData.videosAudios.length ? getCCSubsForPartner(selectedPartner) : [];
        }
        setVideoData();
    };

    var getPreviewData = function () {
        $scope.$emit('server-busy', {working: true});
        var mediaPromise = PreviewQueryService.getPackageMedia(self.packageObject.id);
        var partnerPackagesPromise = PreviewQueryService.getPartnerPackages(self.packageObject.id);
        var dynamicPropsPromise = DynamicPropertiesService.queryForProperties();
        var downloadViewStatePromise = PermissionsService.getPackagePermissions(DOWNLOAD_PROXY_STATE, self.packageObject.id);
        var writePermsPromise = PermissionsService.canWrite(PREVIEW_TAB_VIEW_STATE);
        var recreateProxyPerm = PermissionsService.canWrite(RECREATE_PROXY_STATE);

        return $q.all({
            media: mediaPromise,
            partners: partnerPackagesPromise,
            dynamicProps: dynamicPropsPromise,
            writePerms: writePermsPromise,
            viewDownloadPerms: downloadViewStatePromise,
            recreatePerms: recreateProxyPerm
        }).then(function (data) {
            masterMediaData = data.media;
            self.canReplaceExistingImages = DynamicPropertiesService.getPropValueAsBoolean('ffmpeg.frameGrabber.replaceExistingImages', false);
            self.perms = {
                write: data.writePerms,
                download: (data.viewDownloadPerms[0].permission & PermissionsService.WRITE_PERMISSION) === PermissionsService.WRITE_PERMISSION,
                recreate: data.recreatePerms,
                exception: data.viewDownloadPerms[0].availableAt
            };
            self.mainVideo = masterMediaData[defaultMediaRole] && masterMediaData[defaultMediaRole].video && masterMediaData[defaultMediaRole].video[0];
            self.currentViewData.partners = data.partners;
            setVideoContentDefaults(masterMediaData[defaultMediaRole]);
            setNonVideoDefaults(masterMediaData[defaultMediaRole]);
            setVideoData();
            self.loading = false;
        });
    };

    self.showVideoTab = function (tab) {
        if (tab === 'details') {
            return self.selectedVideoAudio && self.selectedVideoAudio.assetId ? true : false;
        }
        if (tab === 'markers') {
            return self.selectedVideoAudio && !self.selectedVideoAudio.prePostRollId && self.mainVideo && self.mainVideo.chapters && self.mainVideo.chapters.length ? true : false;
        }
        if (tab === 'adpods') {
            return self.selectedVideoAudio && !self.selectedVideoAudio.prePostRollId && self.currentViewData.adpod && self.currentViewData.adpod.length ? true : false;
        }
        if (tab === 'components') {
            return self.selectedVideoAudio && self.selectedVideoAudio.isComponentMaster ? true : false;
        }
        else {
            return self.captionsGrid && self.captionsGrid.data && self.captionsGrid.data.length ? true : false;
        }
    };

    var setActiveTab = function () {
        if (self.showVideoTab('details')) {
            self.currentViewedTab = 'details';
        } else if (self.showVideoTab('markers')) {
            self.currentViewedTab = 'markers';
        } else if (self.showVideoTab('adpods')) {
            self.currentViewedTab = 'adpods';
        } else if (self.showVideoTab('components')) {
            self.currentViewedTab = 'components';
        } else {
            self.currentViewedTab = 'captions';
        }
    };

    var getCuePoints = function () {
        var cuePoints = [];
        if (self.showVideoTab('adpods')) {
            angular.forEach(self.currentViewData.adpod[0].adpods, function (adpod) {
                cuePoints.push({
                    timeLapse: {
                        start: adpod.startTime,
                        end: adpod.endTime
                    },
                    cuePointClass: 'adpod-cue-point'
                });
            });
        }
        if (self.showVideoTab('components')) {
            angular.forEach(self.componentsGrid.data, function (component) {
                cuePoints.push({
                    timeLapse: {
                        start: getSeekTime(component.in, true),
                        end: getSeekTime(component.out, true)
                    },
                    cuePointClass: 'component-cue-point'
                });
            });
        }
        return cuePoints;
    };

    self.download = function (type) {
        let filename = !!this.packageObject ?
            PackageMediaService.generatePackageDownloadFilenamePrefix(this.packageObject, false) :
            'unknown_';
        filename += `${type}_proxy.`;
        if (type === 'video' || type === 'audio') {
            filename += UtilsService.getFileExtension(self.selectedVideoAudio.proxyPath);
            DownloadAssetService.downloadAsset(self.selectedVideoAudio.assetId, filename, type, DownloadAssetService.ContentUse.Proxy);
        } else if (type === 'image') {
            filename += UtilsService.getFileExtension(self.selectedImage.mediaPath);
            DownloadAssetService.downloadAsset(self.selectedImage.assetId, filename, type, DownloadAssetService.ContentUse.Proxy);
        } else {
            filename += UtilsService.getFileExtension(self.selectedArtwork.mediaPath);
            DownloadAssetService.downloadAsset(self.selectedArtwork.assetId, filename, type, DownloadAssetService.ContentUse.Proxy);
        }
    };

    self.createSnapshot = function () {
        self.creatingSnapshots[self.mainVideo.id] = true;
        self.tempImagePath = CreateSnapshotService.getSnapshotImage($element.find('video')[0]);
        CreateSnapshotService.createSnapshot(self.packageObject.id, ProxyPlayerService.playerTime)
            .then(getPreviewData)
            .finally(function () {
                self.tempImagePath = undefined;
                self.creatingSnapshots[self.mainVideo.id] = false;
            });
    };

    self.createProxy = function (type) {
        var id;
        if (type === 'video') {
            if (self.selectedVideoAudio.prePostRollId) {
                CreateProxyService.createPrePostRollProxy(self.selectedVideoAudio.id);
            }
            else if (self.selectedVideoAudio.isComponentMaster) {
                CreateProxyService.createComponentMasterProxy(self.selectedVideoAudio.id);
            }
            else {
                CreateProxyService.createVideoProxy(self.selectedVideoAudio.id);
            }
            id = self.selectedVideoAudio.id;
        }
        else if (type === 'audio') {
            CreateProxyService.createAudioProxy(self.selectedVideoAudio.id);
            id = self.selectedVideoAudio.id;
        }
        else {
            CreateProxyService.createImageProxy(self.selectedImage.id);
            id = self.selectedImage.id;
        }
        self.createdProxies[id] = true;
    };

    self.showImageInfoModal = function (packageContent) {
        let imageAssetInfoRendererTemplate = 'package/editor/components/view/preview/renderers/image/preview-image-info-render-template.html';
        let fileNamePrefix = !!this.packageObject ?
            PackageMediaService.generatePackageDownloadFilenamePrefix(this.packageObject, false) :
            'unknown_';
        ModalService.showViewAssetModal(packageContent, false, fileNamePrefix, imageAssetInfoRendererTemplate, false);
    };

    self.showArtworkInfoModal = function (packageContent) {
        let artworkAssetInfoRendererTemplate = 'package/editor/components/view/preview/renderers/artwork/preview-artwork-info-renderer-template.html';
        ModalService.showAssetModal(packageContent, artworkAssetInfoRendererTemplate);
    };

    self.canViewProxy = function () {
        var hasPerms = self.perms.write && self.perms.download;
        var proxyHasReleased = !self.perms.exception || new Date(self.perms.exception).getTime() <= new Date().getTime();
        return hasPerms && proxyHasReleased;
    };

    self.canCreateSnapshot = function () {
        var hasPerms = self.perms.write;
        var previewingMainVideo = self.mainVideo && self.selectedVideoAudio && !self.selectedVideoAudio.isAudio && self.selectedVideoAudio.id === self.mainVideo.id;
        var hasImages = self.currentViewData && self.currentViewData.images && self.currentViewData.images.length;
        var createClicked = self.mainVideo && self.creatingSnapshots[self.mainVideo.id];
        return hasPerms && previewingMainVideo && (self.canReplaceExistingImages || !hasImages) && !createClicked;
    };

    self.canCreateProxy = function (mediaObj) {
        var hasPerms = self.perms.write && self.perms.recreate;
        var statusAllows = mediaObj && (!mediaObj.ingestInfo || !mediaObj.ingestInfo.proxyWorkflowStatus || mediaObj.ingestInfo.proxyWorkflowStatus === 'COMPLETED');
        var createClicked = mediaObj && self.createdProxies[mediaObj.id];
        return hasPerms && statusAllows && !createClicked;
    };

    self.videoAudioRoleChange = function () {
        if (self.selectedVideoAudio.prePostRollId || self.selectedVideoAudio.isAudio) {
            self.previewPlayerOffset = self.selectedVideoAudio.isAudio ? 0 : getSeekTime('01:00:00:00', false);
            self.useMasterVideoOffset = false;
        } else {
            startTimecodeInSeconds = getSeekTime(self.mainVideoWithMediaInfo.video[0].startTimecode, false);
            self.previewPlayerOffset = startTimecodeInSeconds;

            if (self.selectedVideoAudio.dropdownLabel === defaultMediaRole) {
                self.currentViewData.ccSubtitles = getCCSubtitles(masterMediaData[defaultMediaRole]);
            }

            if (self.selectedVideoAudio.isComponentMaster) {
                currentlySelectedComponent = self.selectedVideoAudio.dropdownLabel.split('+')[1].trim();
                if (masterMediaData[currentlySelectedComponent].cc || masterMediaData[currentlySelectedComponent].subtitles) {
                    self.currentViewData.ccSubtitles = getCCSubtitles(masterMediaData[currentlySelectedComponent]);
                } else {
                    self.currentViewData.ccSubtitles = getCCSubtitles(masterMediaData[defaultMediaRole]);
                }
            }
            self.selectedCCSub = self.currentViewData.ccSubtitles[0];

            self.useMasterVideoOffset = self.isMasterVideo;
        }
        self.masterVideoOffsetChangeHandler();
    };

    // Form should never be dirty
    $scope.$watch(function () {
            return PackageUtilService.editorForm && PackageUtilService.editorForm.$dirty;
        },
        function (newVal, oldVal) {
            if (PackageUtilService.editorForm && newVal !== oldVal) {
                PackageUtilService.editorForm.$setPristine();
            }
        });

    $scope.$watch(function () {
        return self.editorForm;
    }, function (newValue) {
        PackageUtilService.editorForm = newValue;
    });

    $scope.$watch(function () {
            return self.selectedVideoAudio;
        },
        function (newVal) {
            if (newVal) {
                if (newVal.isAudio) {
                    self.cuePoints = [];
                }
                else {
                    if (newVal.prePostRollId) {
                        self.selectedCCSub = undefined;
                    }
                    setActiveTab();
                    handleSelectedVideoAudioChange(self.selectedPartner);
                    self.cuePoints = getCuePoints();
                }
            }
        });

    $scope.$watch(function () {
            return self.selectedVideoAudio && self.selectedVideoAudio.selectedMarker;
        },
        function (newVal) {
            if (typeof newVal === 'number') {
                ProxyPlayerService.seek(newVal);
            }
        });

    $scope.$watch(function () {
            return self.selectedPartner;
        },
        function (newVal, oldVal) {
            if (oldVal !== newVal) {
                handlePartnerChange(newVal);
            }
        });

    $scope.$watch(function () {
            return self.selectedArtworkPartner;
        },
        function (newVal) {
            if (newVal) {
                self.selectedArtworkLanguage = self.selectedArtworkPartner.languagesData[0];
            }
        });

    $scope.$watch(function () {
            return self.selectedArtworkLanguage;
        },
        function (newVal) {
            if (newVal) {
                self.selectedArtwork = self.selectedArtworkLanguage.assets[0];
            }
        });

    $scope.$on('$destroy', function () {
        ProxyPlayerService.onTimeUpdate = null;
        ProxyPlayerService.onChangedState = null;
    });

    getPreviewData();
});
